document.addEventListener('DOMContentLoaded', () => {
  const predictiveSearchElements = document.querySelectorAll('predictive-search');

  predictiveSearchElements.forEach((instance) => {
    const input = instance.querySelector('input[type="search"]');
    const select = instance.querySelector('#SearchProductTypes');

    if (!input) return;

    instance.abortController = new AbortController();
    instance.cachedResults = {};

    // Listen for collection dropdown changes
    if (select) {
      select.addEventListener('change', () => {
        const term = input.value.trim();
        if (term.length > 0) {
          const event = new Event('input', { bubbles: true });
          input.dispatchEvent(event);
        }
      });
    }

    instance.getSearchResults = function (searchTerm) {
      if (!searchTerm || searchTerm.trim().length === 0) return;

      const selectedCollection = select ? select.value.trim() : '';
      const key = selectedCollection ? `${selectedCollection}-${searchTerm}` : searchTerm;

      if (this.cachedResults[key]) {
        this.renderSearchResults(this.cachedResults[key]);
        return;
      }

      if (!window.routes || !routes.predictive_search_url) return;

      let url = `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`;

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      if (this.setLiveRegionLoadingState) this.setLiveRegionLoadingState();

      fetch(url, { signal: this.abortController.signal })
        .then((r) => r.text())
        .then((text) => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(text, 'text/html');
          const container = htmlDoc.querySelector('#shopify-section-predictive-search');

          let html = container ? container.innerHTML : '';

          // --- FILTER PRODUCTS BY COLLECTION ---
          if (selectedCollection) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            const productItems = tempDiv.querySelectorAll('[data-predictive-search-product]');
            productItems.forEach((item) => {
              const collectionHandles = (item.getAttribute('data-collection-handles') || '').split(',');
              if (!collectionHandles.includes(selectedCollection)) {
                item.remove(); // remove products not in selected collection
              }
            });

            html = tempDiv.innerHTML;
          }

          // --- SHOW NO RESULTS MESSAGE IF EMPTY ---
          const tempDivCheck = document.createElement('div');
          tempDivCheck.innerHTML = html;
          const hasItems = tempDivCheck.querySelectorAll('li').length > 0;

          if (!hasItems) {
            html = `<div class="predictive-search__no-results">
                      <p>No results found for “${searchTerm}”.<br>Check the spelling or use a different word or phrase.</p>
                    </div>`;
          }

          this.cachedResults[key] = html;
          if (this.renderSearchResults) this.renderSearchResults(html);
        })
        .catch((err) => {
          if (err.name !== 'AbortError') console.error('Predictive search fetch error:', err);
        });
    };
  });
});
